import { useEffect, useLayoutEffect, useRef } from 'react';
import eventBus from './eventBus/eventBus';

export default function useEventBus<T extends string = never>(
  eventType: T,
  callback: (payload: object | null | undefined) => void
) {
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    const handler = (payload: object | null | undefined) => {
      callbackRef.current(payload);
    };
    return eventBus.on<T>(eventType, handler);
  }, [eventType]);
}
